import { useCallback } from 'react';

export const useSelectionManager = props => {
  const { relationKey, singleSelect, valueKey, labelKey } = props;

  const handleSelectionChange = useCallback(
    (selectedOptions, onChange, onRadioChange, valueList) => {
      if (singleSelect) {
        const selectedValue = selectedOptions ? selectedOptions.value : null;

        if (relationKey && selectedOptions && selectedOptions.data) {
          const relationData = { [relationKey]: selectedOptions.value, ...valueList[selectedOptions.value].relation };
          if (onChange) onChange([relationData]);
        } else {
          if (onChange) onChange(selectedValue);
          if (onRadioChange) onRadioChange(selectedValue);
        }
      } else {
        const selectedValues = Array.isArray(selectedOptions) ? selectedOptions : [];

        if (relationKey) {
          // Ensure selectedValues is an array
          const safeSelectedValues = Array.isArray(selectedValues) ? selectedValues : [];

          const relations = safeSelectedValues
            .filter(option => option && option.value != null) // ensure option exists
            .map(option => {
              const value = option.value;

              // ensure valueList exists and has a valid entry
              const relationData =
                valueList && valueList[value] && valueList[value].relation ? valueList[value].relation : {};

              return {
                [relationKey]: value,
                ...relationData,
              };
            });

          if (typeof onChange === 'function') {
            onChange(relations);
          }
        } else {
          const values = selectedValues.map(option => option.value);
          if (onChange) onChange(values);
        }
      }
    },
    [singleSelect, relationKey]
  );

  return {
    handleSelectionChange,
  };
};
